import React, { useState } from 'react';
import '../styles/StyledDelivery.css'; // your CSS file

export default function StyledDelivery() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="div3 flex flex-col md:flex-row px-4 md:px-16 py-10 md:py-24 gap-10 items-center justify-between">
      {/* LEFT SIDE */}
      <div className="div3a text-center md:text-left flex flex-col items-center md:items-start">
        <h1 className="text-[28px] md:text-[40px] font-bold leading-tight w-full md:w-[60%]">
          Style Delivered: Elevate Your Wardrobe with Just a Click
        </h1>

      </div>

      {/* RIGHT SIDE */}
      <div className="div3b text-center">
        <div
          className="imagehover"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <div className="image-container">
            <img
              src="/images/up3.png"
              alt="Elevated Style"
              className={`image image-1 ${hovered ? 'hovered' : ''}`}
            />
            <img
              src="/images/down3.png"
              alt="Delivered with Ease"
              className={`image image-2 ${hovered ? 'hovered' : ''}`}
            />
          </div>
        </div>
        <h2 className="mt-12 text-[18px] md:text-[24px] text-currentnav font-semibold w-full md:w-[60%] mx-auto">
          “Fashion at Your Fingertips: Discover, Shop, Shine"
        </h2>
      </div>
    </div>
  );
}
